import { useMemo } from 'react'

import useBrands from 'pared/layouts/hooks/useBrands'
import { getUser } from 'pared/utils/user'

import configs from '../configs'

const useAccessiblePages = () => {
  const user = getUser()
  const { brand } = useBrands()

  return useMemo(
    () =>
      (user.accessiblePages ?? []).reduce((result, accessiblePage) => {
        const key = [brand, accessiblePage].join('-')

        return {
          ...result,
          ...configs[key],
        }
      }, configs[brand] || {}),
    [user, brand],
  )
}

export default useAccessiblePages
